import {ROLE_ADMIN} from '../../../helpers'

export const SupportUser = [{
  path: 'support-users',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'SupportUser',
      component: () => import('../../../components/Admin/SupportUser'),
      meta: {
        access: [ROLE_ADMIN]
      }
    },
    {
      path: 'create',
      name: 'SupportUserCreate',
      component: () => import('../../../components/Admin/SupportUser/create'),
      meta: {
        access: [ROLE_ADMIN]
      }
    },
    {
      path: 'edit/:id',
      name: 'SupportUserEdit',
      component: () => import('../../../components/Admin/SupportUser/edit'),
      meta: {
        access: [ROLE_ADMIN]
      }
    }
  ]
}]



// WEBPACK FOOTER //
// /src/router/admin/module/supportUser.js